// extracted by mini-css-extract-plugin
export default {"list":"banner4_list__NuLQB","span_text":"banner4_span_text__VJNte","text_color":"banner4_text_color__SADys","margins":"banner4_margins__SKqCm"};